import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './aidas-upload.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasUploadDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const aidasUploadEntity = useAppSelector(state => state.aidasUpload.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="aidasUploadDetailsHeading">AidasUpload</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{aidasUploadEntity.id}</dd>
          <dt>
            <span id="name">Name</span>
          </dt>
          <dd>{aidasUploadEntity.name}</dd>
          <dt>
            <span id="dateUploaded">Date Uploaded</span>
          </dt>
          <dd>
            {aidasUploadEntity.dateUploaded ? (
              <TextFormat value={aidasUploadEntity.dateUploaded} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="status">Status</span>
          </dt>
          <dd>{aidasUploadEntity.status ? 'true' : 'false'}</dd>
          <dt>
            <span id="statusModifiedDate">Status Modified Date</span>
          </dt>
          <dd>
            {aidasUploadEntity.statusModifiedDate ? (
              <TextFormat value={aidasUploadEntity.statusModifiedDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="rejectReason">Reject Reason</span>
          </dt>
          <dd>{aidasUploadEntity.rejectReason}</dd>
          <dt>Aidas User Aidas Object Mapping</dt>
          <dd>{aidasUploadEntity.aidasUserAidasObjectMapping ? aidasUploadEntity.aidasUserAidasObjectMapping.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/aidas-upload" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/aidas-upload/${aidasUploadEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default AidasUploadDetail;
